import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute, RequireModule  } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/portais
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
// Usando Directory Routes: dashboard.$dashboardId.portais/route.tsx
// route.tsx = layout route (sempre renderizado)
// Renderiza o <Outlet /> para as rotas filhas (index.tsx, $portalvalue/index.tsx, etc)
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/portais',
)({
  component: function PortaisLayout() {
    const { dashboardId } = Route.useParams()
    return (
      <ProtectedRoute capability={CAPABILITIES.EDIT_IMOB_DATA} dashboardId={dashboardId}>
        <RequireModule module={MODULES.PORTAIS} dashboardId={dashboardId}>
          <Outlet />
        </RequireModule>
      </ProtectedRoute>
    )
  },
})
